// extracted by mini-css-extract-plugin
export default {"title":"RequestPasswordRecovery_title__a7GRU","text":"RequestPasswordRecovery_text__uy0Kf","form":"RequestPasswordRecovery_form__sgGmx"};